export var MessageType;
(function (MessageType) {
    MessageType[MessageType["INVALID"] = 0] = "INVALID";
    MessageType[MessageType["REDIRECT"] = 1] = "REDIRECT";
    MessageType[MessageType["SET_HEIGHT"] = 2] = "SET_HEIGHT";
    MessageType[MessageType["SCROLL_TO_TOP"] = 3] = "SCROLL_TO_TOP";
    MessageType[MessageType["STORE_SCROLL_POSITION"] = 4] = "STORE_SCROLL_POSITION";
    MessageType[MessageType["RESTORE_SCROLL_POSITION"] = 5] = "RESTORE_SCROLL_POSITION";
    MessageType[MessageType["UPDATE_CART"] = 6] = "UPDATE_CART";
    MessageType[MessageType["SHOW_MODAL"] = 7] = "SHOW_MODAL";
    MessageType[MessageType["SET_HEIGHT_IN_MODAL"] = 8] = "SET_HEIGHT_IN_MODAL";
    MessageType[MessageType["CLOSE_MODAL"] = 9] = "CLOSE_MODAL";
    MessageType[MessageType["GENERIC_IFRAME_MESSAGE"] = 10] = "GENERIC_IFRAME_MESSAGE";
    MessageType[MessageType["UPDATE_BREADCRUMBS"] = 11] = "UPDATE_BREADCRUMBS";
    MessageType[MessageType["NAVIGATED"] = 12] = "NAVIGATED";
    MessageType[MessageType["VIEW_CHANGED"] = 13] = "VIEW_CHANGED";
    MessageType[MessageType["RX_REMOVED_FROM_CART"] = 14] = "RX_REMOVED_FROM_CART";
    MessageType[MessageType["QUANTITY_CHANGE_REASON"] = 15] = "QUANTITY_CHANGE_REASON";
    MessageType[MessageType["SET_ERROR"] = 16] = "SET_ERROR";
    MessageType[MessageType["ESCAPE_KEY_PRESSED"] = 17] = "ESCAPE_KEY_PRESSED";
    MessageType[MessageType["REDIRECT_TO_ERROR_PAGE"] = 18] = "REDIRECT_TO_ERROR_PAGE";
    MessageType[MessageType["MODIFY_MODAL_SWIPEABLE_OVERLAY"] = 19] = "MODIFY_MODAL_SWIPEABLE_OVERLAY";
    MessageType[MessageType["MODAL_CLOSED"] = 20] = "MODAL_CLOSED";
    MessageType[MessageType["REQUEST_FOR_FOCUS_OUTSIDE_IFRAME"] = 21] = "REQUEST_FOR_FOCUS_OUTSIDE_IFRAME";
    MessageType[MessageType["MOVE_FOCUS_INTO_IFRAME"] = 22] = "MOVE_FOCUS_INTO_IFRAME";
    MessageType[MessageType["SHOW_DOWNLOAD_PRESCRIPTION_HISTORY_BUTTON"] = 23] = "SHOW_DOWNLOAD_PRESCRIPTION_HISTORY_BUTTON";
    MessageType[MessageType["DOWNLOAD_PRESCRIPTION_HISTORY"] = 24] = "DOWNLOAD_PRESCRIPTION_HISTORY";
    MessageType[MessageType["SET_DATE"] = 25] = "SET_DATE";
    MessageType[MessageType["SHOW_COOLED_PRODUCT_CONFLICT_MODAL"] = 26] = "SHOW_COOLED_PRODUCT_CONFLICT_MODAL";
    MessageType[MessageType["TRIGGER_OPEN_DELIVERY_MODAL"] = 27] = "TRIGGER_OPEN_DELIVERY_MODAL";
    MessageType[MessageType["GET_ECOM_DATA_REQUEST"] = 28] = "GET_ECOM_DATA_REQUEST";
    MessageType[MessageType["GET_ECOM_DATA_RESPONSE"] = 29] = "GET_ECOM_DATA_RESPONSE";
    // this value is used for new message badge, if you need to change it
    // update also value in unread-messages-badge.html
    MessageType[MessageType["NEW_MESSAGE"] = 999] = "NEW_MESSAGE";
})(MessageType || (MessageType = {}));
